import type { ListType } from "@/interface/common";

interface ExtendListType {
  class: string;
  activeClass: string;
}
export const themeList: ListType<ExtendListType> = [
  {
    label: "默认",
    value: "default",
    class: "default-class",
    activeClass: "default-class-active",
  },
  {
    label: "拿铁棕韵",
    value: "brown",
    class: "brown-class",
    activeClass: "brown-class-active",
  },
  {
    label: "梦幻星空",
    value: "silver",
    class: "silver-class",
    activeClass: "silver-class-active",
  },
  {
    label: "幻影黑金",
    value: "dark",
    class: "dark-class",
    activeClass: "dark-class-active",
  },
];
